/**
 * ScrollToTop - Floating button to scroll back to top
 * Appears after scrolling 800px or loading multiple batches
 */
import { useState, useEffect } from "react";
import { ArrowUp } from "lucide-react";
import { Button } from "@/components/ui/button";

export function ScrollToTop({ threshold = 800 }) {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const scrollY = window.scrollY || document.documentElement.scrollTop;
      setIsVisible(scrollY > threshold);
    };

    // Initial check
    handleScroll();

    // Add scroll listener with passive option for performance
    window.addEventListener("scroll", handleScroll, { passive: true });

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [threshold]);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <Button
      onClick={scrollToTop}
      className={`
        fixed bottom-20 right-6 z-50
        h-12 w-12 rounded-full
        bg-slate-900 hover:bg-slate-800
        shadow-lg hover:shadow-xl
        transition-all duration-300 ease-in-out
        ${isVisible 
          ? "opacity-100 translate-y-0 pointer-events-auto" 
          : "opacity-0 translate-y-4 pointer-events-none"
        }
      `}
      size="icon"
      data-testid="scroll-to-top-btn"
      aria-label="Scroll to top"
    >
      <ArrowUp className="h-5 w-5 text-white" />
    </Button>
  );
}
